import axios from "axios";
import { getArgs, addUrlPerFix } from "@/basa/utils";

export const mixinSys = {
  data() {
    return {
      dialogVisible: false,
      reportUrl: ""
    };
  },
  methods: {
    downloadEnclosure(reportName) {
      if (!reportName) {
        return this.$message.error("暂无附件!");
      }
      const loading = this.$loading({
        text: "加载中，请稍等",
        spinner: "el-icon-loading"
      });

      let obj = {
        reportName
        // reportName: '八诗八声（上海）文化传媒有限公司_10050_1693662.pdf'
      };
      obj.agentId = getArgs("a");
      const baseURL = addUrlPerFix("scma.iccec.cn");
      return axios
        .create({
          timeout: 600000 // 设置超时时间（单位：毫秒）
        })
        .post(baseURL + `/apis/scma/subYgyEva/dealSubYgyEvaFileDownload`, obj, {
          responseType: "blob"
        })
        .then(res => {
          if (res) {
            loading.close();
            this.dialogVisible = true;
            let file = res.data;
            let blob = new Blob([file], {
              type: res.data.type
            });
            let url = window.URL.createObjectURL(blob);
            this.reportUrl = url;
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.loading = false;
          this.$message.error("导出数据失败!");
        });
    }
  }
};
